import React from "react";
import { Navigate } from "react-router-dom";
import { useUiVersion } from "../UiVersionContext";
import GenerateScanLink from "./GenerateScanLink";

// /scan-links/new predates the v2 shell, so it renders the v1 page for everyone —
// including users whose preference is v2, who get dropped out of their shell onto an
// interface they have opted out of. v2 already has this screen (registry key
// "scan-links"), it just had no URL, so the fix is to send v2 users to it rather than
// to grow a second copy of the page.
//
// `replace` on purpose: the redirect should not sit in history, or Back from the
// dashboard bounces straight through it again.
const ScanLinkRoute = () => {
  const { uiVersion } = useUiVersion();
  return uiVersion === "v2"
    ? <Navigate to="/dashboard?tab=scan-links" replace />
    : <GenerateScanLink />;
};

export default ScanLinkRoute;
